// auto-generated by Typewriter template _enums.tst from PortCall.Models\PortCall\BatchRecurrencePeriod.cs
export enum BatchRecurrenceFrequency { 
    Daily = 0,
    Weekly = 1,
    Monthly = 2,
    Custom = 3
}

export const BatchRecurrenceFrequencyDisplayName : { [val : number] : string } = { 
    0: 'Daily',
    1: 'Weekly',
    2: 'Monthly',
    3: 'Custom'
}

export const BatchRecurrenceFrequencys : { Id : BatchRecurrenceFrequency, Name : string }[] = [ 
    { Id: BatchRecurrenceFrequency.Daily, Name: 'Daily' },
    { Id: BatchRecurrenceFrequency.Weekly, Name: 'Weekly' },
    { Id: BatchRecurrenceFrequency.Monthly, Name: 'Monthly' },
    { Id: BatchRecurrenceFrequency.Custom, Name: 'Custom' }
]



// WEBPACK FOOTER //
// ./server/enums/BatchRecurrenceFrequency.ts